var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNdb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.25,
    height: 43.25,
    viewBox: "0 0 43.25 43.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4183",
    transform: "translate(6.312 -54.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3816",
    transform: "translate(-56.312 -45.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3586",
    d: "M80,125a5,5,0,1,1-5-5A5,5,0,0,1,80,125Z",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3588",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 98.125)",
    fill: "#ff80d5",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3648",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 88.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3650",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 108.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3656",
    transform: "translate(-52.452 54.247) rotate(-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3658",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 88.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3660",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 108.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3662",
    transform: "translate(-70.753 127.452) rotate(-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3664",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 88.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3666",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 108.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3668",
    transform: "translate(-50 200) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3670",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 88.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3672",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 108.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3674",
    transform: "translate(4.247 252.452) rotate(-120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3676",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 88.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3678",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 108.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3680",
    transform: "translate(77.452 270.753) rotate(-150)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3682",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 88.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3684",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 108.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3690",
    transform: "translate(-45.8 43.408) rotate(-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3686",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 83.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3688",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 113.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3694",
    transform: "translate(-66.421 89.645) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3696",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 83.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3698",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 113.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3700",
    transform: "translate(-69.985 140.146) rotate(-65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3702",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 83.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3704",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 113.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3706",
    transform: "translate(-56.061 188.82) rotate(-85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3708",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 83.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3710",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 113.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3712",
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, -26.329, 229.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3714",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 83.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3716",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 113.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3718",
    transform: "matrix(-0.574, -0.819, 0.819, -0.574, 15.624, 258.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3720",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 83.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3722",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 113.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3724",
    transform: "matrix(-0.819, -0.574, 0.574, -0.819, 64.739, 270.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3726",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 83.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3728",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 113.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3730",
    transform: "matrix(-0.966, -0.259, 0.259, -0.966, 115.092, 265.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3732",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 83.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3734",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 113.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3736",
    transform: "translate(160.609 242.988) rotate(175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3738",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 83.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3740",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 113.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3742",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 118.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3744",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 78.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3750",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, -29.797, 23.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3752",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 118.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3754",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 78.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3756",
    transform: "translate(-52.452 54.247) rotate(-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3758",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 118.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3760",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 78.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3762",
    transform: "translate(-66.421 89.645) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3764",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 118.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3766",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 78.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3768",
    transform: "translate(-70.753 127.452) rotate(-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3770",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 118.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3772",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 78.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3774",
    transform: "matrix(0.259, -0.966, 0.966, 0.259, -65.152, 165.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3776",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 118.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3778",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 78.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3780",
    transform: "translate(-50 200) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3782",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 118.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3784",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 78.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3786",
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, -26.329, 229.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3788",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 118.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3790",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 78.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3792",
    transform: "translate(4.247 252.452) rotate(-120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3794",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 118.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3796",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 78.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3798",
    transform: "translate(39.645 266.421) rotate(-135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3800",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 118.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3802",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 78.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3804",
    transform: "translate(77.452 270.753) rotate(-150)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3806",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 118.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3808",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 78.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3810",
    transform: "matrix(-0.966, -0.259, 0.259, -0.966, 115.092, 265.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3812",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 118.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3814",
    d: "M12.5,26.875a.625.625,0,1,1-.625-.625A.625.625,0,0,1,12.5,26.875Z",
    transform: "translate(63.125 78.125)",
    fill: "none",
    stroke: "#ff80d5",
    strokeLinecap: "square",
    strokeWidth: 2
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNdb);
export default __webpack_public_path__ + "static/media/NDB.2cf30274d1e3c9bd90a3d93ffdd80f16.svg";
export { ForwardRef as ReactComponent };